var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "mb-2 mt-6",
              class: { "mt-n12": _vm.smAndDown },
              attrs: { cols: "12" },
            },
            [
              _c(
                "v-row",
                { staticClass: "px-0 py-0" },
                [
                  _c("v-col", { attrs: { cols: "auto" } }, [
                    _c("label", { staticClass: "section-heading" }, [
                      _vm._v("Commodity Information"),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { key: _vm.formResetKey },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("smart-combobox", {
                    attrs: {
                      items: _vm.localEquipmentTypesDdl,
                      label: "Equipment Type",
                      required: _vm.validateCommodityForm,
                      outlined: "",
                    },
                    on: { change: _vm.onEquipmentTypeChange },
                    model: {
                      value: _vm.localEquipmentType,
                      callback: function ($$v) {
                        _vm.localEquipmentType = $$v
                      },
                      expression: "localEquipmentType",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c("v-col", { attrs: { cols: "12" } }, [
                _c(
                  "label",
                  {
                    staticStyle: {
                      color: "#0B436A",
                      "font-family": "Poppins",
                      "font-size": "13px",
                      "font-style": "normal",
                      "font-weight": "600",
                      "line-height": "24px",
                    },
                  },
                  [_vm._v("Commodities")]
                ),
              ]),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticClass: "d-flex align-center mb-2",
                  attrs: { cols: "12" },
                },
                [
                  _c("smart-btn", {
                    attrs: {
                      type: "primary",
                      icon: _vm.ic_plus,
                      "icon-class": "mr-2",
                      "icon-width": "14",
                      "icon-position": "left",
                      label: "PRODUCT LIST",
                    },
                    on: {
                      click: function ($event) {
                        _vm.showProductListPopup = true
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("smart-text-field", {
                    ref: "commodityNameField",
                    attrs: {
                      placeholder: "Name",
                      required: _vm.validateCommodityForm,
                      maxlength: "255",
                    },
                    model: {
                      value: _vm.commodityForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.commodityForm, "name", $$v)
                      },
                      expression: "commodityForm.name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6" } },
                [
                  _c("smart-text-field", {
                    ref: "commodityPiecesField",
                    attrs: {
                      placeholder: "Number of Pieces",
                      number: true,
                      required: _vm.validateCommodityForm,
                      max: "999",
                    },
                    model: {
                      value: _vm.commodityForm.pieces,
                      callback: function ($$v) {
                        _vm.$set(_vm.commodityForm, "pieces", $$v)
                      },
                      expression: "commodityForm.pieces",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6" } },
                [
                  _c("smart-text-field", {
                    ref: "commodityWeightField",
                    attrs: {
                      placeholder: "Total Weight",
                      number: true,
                      required: _vm.validateCommodityForm,
                      max: "999999",
                    },
                    model: {
                      value: _vm.commodityForm.weight,
                      callback: function ($$v) {
                        _vm.$set(_vm.commodityForm, "weight", $$v)
                      },
                      expression: "commodityForm.weight",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "12", md: "4" } },
                [
                  _c("smart-text-field", {
                    ref: "commodityLengthField",
                    attrs: {
                      placeholder: "Length",
                      number: true,
                      required: _vm.validateCommodityForm,
                      icon: _vm.ic_dim_times_blue,
                      "icon-position": "right",
                      "icon-slot": "outer",
                      "icon-width": "14",
                      "icon-class": "mr-2 ml-2 times",
                      max: "999",
                    },
                    model: {
                      value: _vm.commodityForm.length,
                      callback: function ($$v) {
                        _vm.$set(_vm.commodityForm, "length", $$v)
                      },
                      expression: "commodityForm.length",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "12", md: "4" } },
                [
                  _c("smart-text-field", {
                    ref: "commodityWidthField",
                    attrs: {
                      placeholder: "Width",
                      number: true,
                      required: _vm.validateCommodityForm,
                      icon: _vm.ic_dim_times_blue,
                      "icon-position": "right",
                      "icon-slot": "outer",
                      "icon-width": "14",
                      "icon-class": "mr-2 ml-2 times",
                      max: "999",
                    },
                    model: {
                      value: _vm.commodityForm.width,
                      callback: function ($$v) {
                        _vm.$set(_vm.commodityForm, "width", $$v)
                      },
                      expression: "commodityForm.width",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "12", md: "4" } },
                [
                  _c("smart-text-field", {
                    ref: "commodityHeightField",
                    attrs: {
                      placeholder: "Height",
                      number: true,
                      required: _vm.validateCommodityForm,
                      max: "999",
                    },
                    model: {
                      value: _vm.commodityForm.height,
                      callback: function ($$v) {
                        _vm.$set(_vm.commodityForm, "height", $$v)
                      },
                      expression: "commodityForm.height",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-checkbox", {
                    attrs: {
                      label: "Does this shipment contain hazardous material?",
                      ripple: false,
                    },
                    model: {
                      value: _vm.serviceInfo.isHazmat,
                      callback: function ($$v) {
                        _vm.$set(_vm.serviceInfo, "isHazmat", $$v)
                      },
                      expression: "serviceInfo.isHazmat",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.serviceInfo.isHazmat
            ? _c(
                "v-row",
                { class: { "mt-n6": _vm.serviceInfo.isHazmat } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("smart-combobox", {
                        attrs: {
                          items: _vm.hazmatQtyTypes,
                          label: "Hazmat Quantity",
                          required: true,
                        },
                        model: {
                          value: _vm.serviceInfo.hazmatQty,
                          callback: function ($$v) {
                            _vm.$set(_vm.serviceInfo, "hazmatQty", $$v)
                          },
                          expression: "serviceInfo.hazmatQty",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("smart-combobox", {
                        attrs: {
                          items: _vm.hazmatClasses,
                          label: "Hazmat Class",
                          required: true,
                          "item-text": "text",
                        },
                        model: {
                          value: _vm.serviceInfo.hazmatClass,
                          callback: function ($$v) {
                            _vm.$set(_vm.serviceInfo, "hazmatClass", $$v)
                          },
                          expression: "serviceInfo.hazmatClass",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("smart-combobox", {
                        attrs: {
                          items: _vm.packingGroupTypes,
                          label: "Package Group",
                          required: true,
                        },
                        model: {
                          value: _vm.serviceInfo.packingGroup,
                          callback: function ($$v) {
                            _vm.$set(_vm.serviceInfo, "packingGroup", $$v)
                          },
                          expression: "serviceInfo.packingGroup",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("smart-text-field", {
                        attrs: {
                          placeholder: "Hazmat Code",
                          required: true,
                          maxlength: "6",
                        },
                        model: {
                          value: _vm.serviceInfo.hazmatCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.serviceInfo, "hazmatCode", $$v)
                          },
                          expression: "serviceInfo.hazmatCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("smart-text-field", {
                        attrs: {
                          placeholder: "Contact Name",
                          required: true,
                          maxlength: "50",
                        },
                        model: {
                          value: _vm.serviceInfo.hazmatContactName,
                          callback: function ($$v) {
                            _vm.$set(_vm.serviceInfo, "hazmatContactName", $$v)
                          },
                          expression: "serviceInfo.hazmatContactName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("smart-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: "(###) ###-####",
                            expression: "'(###) ###-####'",
                          },
                        ],
                        attrs: { placeholder: "Contact Phone", required: true },
                        model: {
                          value: _vm.serviceInfo.hazmatContactPhone,
                          callback: function ($$v) {
                            _vm.$set(_vm.serviceInfo, "hazmatContactPhone", $$v)
                          },
                          expression: "serviceInfo.hazmatContactPhone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "v-row",
        {
          class: {
            "mt-n6": !_vm.serviceInfo.isHazmat,
            "mt-4": _vm.serviceInfo.isHazmat,
          },
        },
        [
          _c(
            "v-col",
            { staticClass: "d-flex justify-end", attrs: { cols: "12" } },
            [
              _c("smart-btn", {
                staticClass: "w-85",
                attrs: {
                  type: "primary",
                  label: "ADD",
                  icon: _vm.ic_plus,
                  "icon-class": "mr-3",
                  "icon-width": "12",
                  "icon-position": "left",
                },
                on: { click: _vm.addCommodity },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showError
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "mt-2",
                      attrs: { color: "#f6123a", dense: "", outlined: "" },
                    },
                    [
                      _c(
                        "v-row",
                        { staticClass: "px-2", attrs: { align: "center" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "grow ta-l d-flex align-start" },
                            [
                              _c("img", {
                                staticClass: "mr-2",
                                staticStyle: { width: "24px" },
                                attrs: { src: _vm.ic_red_warning },
                              }),
                              _c("div", [
                                _c("label", { staticClass: "error-lbl" }, [
                                  _vm._v("Please fill in all required fields:"),
                                ]),
                                _c("div", { staticClass: "dark-text" }, [
                                  _c(
                                    "ul",
                                    { staticClass: "mt-2 mb-0 pl-4" },
                                    _vm._l(_vm.missingFields, function (field) {
                                      return _c("li", { key: field }, [
                                        _vm._v(_vm._s(field)),
                                      ])
                                    }),
                                    0
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.commodities.length > 0
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-simple-table", { staticClass: "commodity-table" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", { staticClass: "action-column" }),
                        _c("th", [_vm._v("Name")]),
                        _c("th", [_vm._v("Pieces")]),
                        _c("th", [_vm._v("Total Weight")]),
                        _c("th", [_vm._v("Size")]),
                        _c("th", [_vm._v("Hazmat")]),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.commodities, function (item, index) {
                        return _c("tr", { key: index }, [
                          _c(
                            "td",
                            { staticStyle: { width: "40px" } },
                            [
                              _c(
                                "v-menu",
                                {
                                  staticClass: "address-menu",
                                  attrs: { bottom: "", left: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "close-btn base mt-n1",
                                                    attrs: { icon: "" },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: _vm.ic_slim_dots,
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    "v-list",
                                    { staticClass: "w-140" },
                                    [
                                      _c(
                                        "v-list-item",
                                        { staticClass: "user-action" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            {
                                              staticClass: "h-40 menu-element",
                                              staticStyle: {
                                                "padding-left": "15px",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.editCommodity(
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-layout",
                                                { staticClass: "mt-1" },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass: "mt_2 pr-8",
                                                      attrs: {
                                                        xs2: "",
                                                        sm2: "",
                                                        md2: "",
                                                        lg2: "",
                                                        xl2: "",
                                                      },
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src: _vm.ic_pencil,
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        xs10: "",
                                                        sm10: "",
                                                        md10: "",
                                                        lg10: "",
                                                        xl10: "",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "edit-lbl",
                                                        },
                                                        [_vm._v("Edit")]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        { staticClass: "user-action" },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            {
                                              staticClass: "h-40 menu-element",
                                              staticStyle: {
                                                "padding-left": "15px",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteCommodity(
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-layout",
                                                { staticClass: "mt-1" },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass: "mt_2 pr-8",
                                                      attrs: {
                                                        xs2: "",
                                                        sm2: "",
                                                        md2: "",
                                                        lg2: "",
                                                        xl2: "",
                                                      },
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticClass: "mr-5",
                                                        attrs: {
                                                          src: _vm.ic_delete,
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        xs10: "",
                                                        sm10: "",
                                                        md10: "",
                                                        lg10: "",
                                                        xl10: "",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "delete-lbl",
                                                        },
                                                        [_vm._v("Delete")]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("td", [_vm._v(_vm._s(item.name))]),
                          _c("td", [_vm._v(_vm._s(item.pieces))]),
                          _c("td", [_vm._v(_vm._s(item.weight))]),
                          _c("td", [
                            _vm._v(
                              _vm._s(item.length) +
                                " x " +
                                _vm._s(item.width) +
                                " x " +
                                _vm._s(item.height)
                            ),
                          ]),
                          _c("td", [_vm._v(_vm._s(item.isHazmat ? "Y" : "-"))]),
                        ])
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px" },
          model: {
            value: _vm.showEditModal,
            callback: function ($$v) {
              _vm.showEditModal = $$v
            },
            expression: "showEditModal",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "br-10 px-5 pt-5 pb-6" },
            [
              _c(
                "v-card-title",
                { staticClass: "justify-center" },
                [
                  _c(
                    "span",
                    {
                      staticClass: "headline modal-popup-title",
                      staticStyle: { "margin-left": "11px" },
                    },
                    [_vm._v("Edit Commodity Information")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          _vm.showEditModal = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("smart-text-field", {
                                attrs: { placeholder: "Name", required: true },
                                model: {
                                  value: _vm.editFormCommodity.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editFormCommodity, "name", $$v)
                                  },
                                  expression: "editFormCommodity.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c("smart-text-field", {
                                attrs: {
                                  placeholder: "Number of Pieces",
                                  number: true,
                                  required: true,
                                },
                                model: {
                                  value: _vm.editFormCommodity.pieces,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editFormCommodity,
                                      "pieces",
                                      $$v
                                    )
                                  },
                                  expression: "editFormCommodity.pieces",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c("smart-text-field", {
                                attrs: {
                                  placeholder: "Total Weight",
                                  number: true,
                                  required: true,
                                },
                                model: {
                                  value: _vm.editFormCommodity.weight,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editFormCommodity,
                                      "weight",
                                      $$v
                                    )
                                  },
                                  expression: "editFormCommodity.weight",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "12", md: "4" } },
                            [
                              _c("smart-text-field", {
                                attrs: {
                                  placeholder: "Length",
                                  number: true,
                                  required: true,
                                  icon: _vm.ic_dim_times_blue,
                                  "icon-position": "right",
                                  "icon-slot": "outer",
                                  "icon-width": "14",
                                  "icon-class": "mr-2 ml-2 times",
                                },
                                model: {
                                  value: _vm.editFormCommodity.length,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editFormCommodity,
                                      "length",
                                      $$v
                                    )
                                  },
                                  expression: "editFormCommodity.length",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "12", md: "4" } },
                            [
                              _c("smart-text-field", {
                                attrs: {
                                  placeholder: "Width",
                                  number: true,
                                  required: true,
                                  icon: _vm.ic_dim_times_blue,
                                  "icon-position": "right",
                                  "icon-slot": "outer",
                                  "icon-width": "14",
                                  "icon-class": "mr-2 ml-2 times",
                                },
                                model: {
                                  value: _vm.editFormCommodity.width,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editFormCommodity,
                                      "width",
                                      $$v
                                    )
                                  },
                                  expression: "editFormCommodity.width",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "12", md: "4" } },
                            [
                              _c("smart-text-field", {
                                attrs: {
                                  placeholder: "Height",
                                  number: true,
                                  required: true,
                                },
                                model: {
                                  value: _vm.editFormCommodity.height,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editFormCommodity,
                                      "height",
                                      $$v
                                    )
                                  },
                                  expression: "editFormCommodity.height",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label:
                                    "Does this shipment contain hazardous material?",
                                  ripple: false,
                                },
                                model: {
                                  value: _vm.editFormCommodity.isHazmat,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editFormCommodity,
                                      "isHazmat",
                                      $$v
                                    )
                                  },
                                  expression: "editFormCommodity.isHazmat",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.editFormCommodity.isHazmat
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("smart-combobox", {
                                    attrs: {
                                      items: _vm.hazmatQtyTypes,
                                      label: "Hazmat Quantity",
                                      required: true,
                                    },
                                    model: {
                                      value: _vm.editFormCommodity.hazmatQty,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editFormCommodity,
                                          "hazmatQty",
                                          $$v
                                        )
                                      },
                                      expression: "editFormCommodity.hazmatQty",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("smart-combobox", {
                                    attrs: {
                                      items: _vm.hazmatClasses,
                                      label: "Hazmat Class",
                                      required: true,
                                      "item-text": "text",
                                    },
                                    model: {
                                      value: _vm.editFormCommodity.hazmatClass,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editFormCommodity,
                                          "hazmatClass",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "editFormCommodity.hazmatClass",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("smart-combobox", {
                                    attrs: {
                                      items: _vm.packingGroupTypes,
                                      label: "Package Group",
                                      required: true,
                                    },
                                    model: {
                                      value: _vm.editFormCommodity.packingGroup,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editFormCommodity,
                                          "packingGroup",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "editFormCommodity.packingGroup",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("smart-text-field", {
                                    attrs: {
                                      placeholder: "Hazmat Code",
                                      required: true,
                                      maxlength: "6",
                                    },
                                    model: {
                                      value: _vm.editFormCommodity.hazmatCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editFormCommodity,
                                          "hazmatCode",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "editFormCommodity.hazmatCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("smart-text-field", {
                                    attrs: {
                                      placeholder: "Contact Name",
                                      required: true,
                                      maxlength: "50",
                                    },
                                    model: {
                                      value:
                                        _vm.editFormCommodity.hazmatContactName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editFormCommodity,
                                          "hazmatContactName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "editFormCommodity.hazmatContactName",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("smart-text-field", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: "(###) ###-####",
                                        expression: "'(###) ###-####'",
                                      },
                                    ],
                                    attrs: {
                                      placeholder: "Contact Phone",
                                      required: true,
                                    },
                                    model: {
                                      value:
                                        _vm.editFormCommodity
                                          .hazmatContactPhone,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editFormCommodity,
                                          "hazmatContactPhone",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "editFormCommodity.hazmatContactPhone",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showEditCommodityError
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "v-alert",
                                    {
                                      staticClass: "mt-2",
                                      attrs: {
                                        color: "#f6123a",
                                        dense: "",
                                        outlined: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "px-2",
                                          attrs: { align: "center" },
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "grow ta-l d-flex align-start",
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "mr-2",
                                                staticStyle: { width: "24px" },
                                                attrs: {
                                                  src: _vm.ic_red_warning,
                                                },
                                              }),
                                              _c("div", [
                                                _c(
                                                  "label",
                                                  { staticClass: "error-lbl" },
                                                  [
                                                    _vm._v(
                                                      "Please fill in all required fields:"
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "dark-text" },
                                                  [
                                                    _c(
                                                      "ul",
                                                      {
                                                        staticClass:
                                                          "mt-2 mb-0 pl-4",
                                                      },
                                                      _vm._l(
                                                        _vm.editMissingFields,
                                                        function (field) {
                                                          return _c(
                                                            "li",
                                                            { key: field },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    field
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "justify-center mt-n6 pr-8" },
                [
                  _c("v-spacer"),
                  _c("smart-btn", {
                    attrs: { type: "primary", label: "SAVE" },
                    on: { click: _vm.saveEditedCommodity },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "400" },
          model: {
            value: _vm.showDeleteConfirmDialog,
            callback: function ($$v) {
              _vm.showDeleteConfirmDialog = $$v
            },
            expression: "showDeleteConfirmDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "br-10 px-5 pt-5 pb-6" },
            [
              _c("v-card-title", { staticClass: "justify-center" }, [
                _c(
                  "label",
                  { staticClass: "headline base header modal-popup-title" },
                  [_vm._v("Delete Commodity?")]
                ),
              ]),
              _c("v-card-text", { staticClass: "ta-c pt-5 pb-2" }, [
                _c("label", { staticClass: "base" }, [
                  _vm._v(
                    "Are you sure you want to delete this commodity? This action cannot be undone."
                  ),
                ]),
              ]),
              _c(
                "v-card-actions",
                { staticClass: "justify-center pt-6" },
                [
                  _c("smart-btn", {
                    staticClass: "mr-4",
                    attrs: { type: "secondary", outlined: "", label: "Cancel" },
                    on: { click: _vm.cancelDelete },
                  }),
                  _c("smart-btn", {
                    staticStyle: { width: "85px" },
                    attrs: { type: "danger", label: "Delete" },
                    on: { click: _vm.confirmDelete },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("product-list", {
        attrs: {
          display: _vm.showProductListPopup,
          userId: _vm.user.userId,
          accountId: _vm.user.accountId,
        },
        on: {
          hide: function ($event) {
            _vm.showProductListPopup = false
          },
          selected: _vm.onProductSelected,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }